module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shop) + " "), (row.seller) ? _c('span', [_vm._v(" / " + _vm._s(row.seller))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.price) + " ")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23496e5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleStats/competitors.vue
// module id = 1249
// module chunks = 2